import { notification } from 'antd'
import {
  CustomTable,
  FilterButton,
  FlexRowBetween,
  PrimaryButton,
  SortButton,
  UserAvatarWithName,
} from 'components'
import { ActionBox } from 'components/ActionBox'
import React, { useMemo, useState } from 'react'
import { ReviewFlaggedCommentModal } from '../modal'
import { StyledCheckbox } from 'components/StyleCloseIcon'

export const FlaggedCommentDisapprovedTab = ({
  selected,
  handleCheckboxChange,
  updateSelection,
  data,
  filter,
  pageChanged,
  total,
  loading,
  refetch,
  handleFilter,
}) => {
  const [openModal, setOpenModal] = useState({
    open: false,
    data: null,
    mode: 'single',
  })

  const handleMultipleReview = () => {
    if (!selected?.length) {
      notification.warning({ message: 'Select Comment' })
      return
    }
    const filteredVideos = data.filter(value => selected.includes(value?._id))
    setOpenModal({
      open: true,
      data: selected?.length === 1 ? filteredVideos[0] : filteredVideos,
      mode: selected?.length === 1 ? 'single' : 'multiple',
    })
  }

  const columns = useMemo(
    () => [
      {
        title: 'Flag',
        dataIndex: 'flag',
        key: 'flag',
        width: 35,
        render: (_, record) => (
          <StyledCheckbox
            onChange={() => handleCheckboxChange(record)}
            checked={selected?.includes(record?._id)}
          />
        ),
      },
      {
        title: 'Comment',
        dataIndex: 'text',
        key: 'text',
      },
      {
        title: 'Commenter',
        dataIndex: 'name',
        key: 'name',
        render: (_, record) => (
          <UserAvatarWithName
            id={record?.user?.fid}
            title={record?.user?.name}
            url={record?.user?.image}
          />
        ),
      },
      {
        title: 'Reason',
        dataIndex: 'flag_reason',
        key: 'flag_reason',
      },
      {
        title: ' Flagged by',
        dataIndex: 'flagger_by',
        key: 'flagger_by',
        render: (_, record) => (
          <UserAvatarWithName
            id={record?.flagged_by?.fid}
            title={record?.flagged_by?.name}
            url={record?.flagged_by?.photo_url}
          />
        ),
      },
      {
        title: 'Action',
        dataIndex: 'Action',
        key: 'Action',
        align: 'right',
        width: 100,
        render: (_, record) => (
          <ActionBox
            item={record}
            withOutConfirmation
            onReview={() =>
              setOpenModal({
                open: true,
                data: record,
                mode: 'single',
              })
            }
          />
        ),
      },
    ],
    [data, selected],
  )

  return (
    <div className="px-5">
      <FlexRowBetween>
        <SortButton
          value={filter.sortBy}
          onSelect={value => handleFilter('sortBy', value)}
        />
        <div className="d-flex align-items-center">
          {selected?.length > 0 && (
            <PrimaryButton onClick={handleMultipleReview} className="me-3">
              Review
            </PrimaryButton>
          )}
          <FilterButton handleFilter={data => handleFilter(data)} />
        </div>
      </FlexRowBetween>
      <CustomTable
        data={data}
        columns={columns}
        pageChanged={pageChanged}
        page={filter?.page}
        pageSize={filter?.limit}
        onAllSelect={flag => updateSelection(data, flag)}
        selected={selected}
        loading={loading}
        total={total}
      />
      {openModal.open && (
        <ReviewFlaggedCommentModal
          visible={openModal.open}
          data={openModal.data}
          refetch={refetch}
          selected={selected}
          mode={openModal.mode}
          tab="disapproved"
          onCancel={() => setOpenModal({ open: false })}
        />
      )}
    </div>
  )
}
